import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthToolsService } from '../auth-tools.service';
import { FailedLoginItem } from './models/failed-login-item.model';
import { catchError, finalize } from 'rxjs/operators';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-failed-logins',
  templateUrl: './failed-logins.component.html',
  styleUrls: ['./failed-logins.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FailedLoginsComponent implements OnInit {
  failedLogins: Array<FailedLoginItem> = [];
  isLoading = false;
  public columnMode = ColumnMode;

  constructor(
    private authToolsService: AuthToolsService,
    private toastrService: ToastrService,
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this.getFailedLogins();
  }

  getLocalLockoutEnd(row: FailedLoginItem) {
    if (!row.lockoutEnd) {
      return null;
    }

    return new Date(row.lockoutEnd).toLocaleString();
  }

  isLockedOut(row: FailedLoginItem) {
    return row.isLockedOut || (!!row.lockoutEnd && new Date(row.lockoutEnd) > new Date());
  }

  getFailedLogins() {
    this.isLoading = true;
    this.failedLogins = [];

    this.authToolsService.getFailedLogins()
      .pipe(finalize(() => this.isLoading = false))
      .subscribe(
        (data) => this.failedLogins = data,
        (error) => {
          console.error(error);
          this.toastrService.error('Failed to load failed logins');
        }
      );
  }

  removeLockout(row: FailedLoginItem) {
    const userId = row.userId;
    this.isLoading = true;
    this.authToolsService.removeLockout(userId)
      .pipe(
        finalize(() => this.isLoading = false)
      )
      .subscribe(
        () => {
          this.toastrService.success('Removed user lockout.');
          this.getFailedLogins();
        },
        (error) => {
          console.error(error);
          this.toastrService.error('Failed to reset user account lockout.');
        }
      )
  }

  lockoutUser(row: FailedLoginItem) {
    const userId = row.userId;
    this.isLoading = true;
    this.authToolsService.lockoutUser(userId)
      .pipe(
        finalize(() => this.isLoading = false)
      )
      .subscribe(
        () => {
          this.toastrService.success('User account locked out.');
          this.getFailedLogins();
        },
        (error) => {
          console.error(error);
          this.toastrService.error('Failed to lockout user account.');
        }
      );
  }

  copyToClipboard(row: FailedLoginItem) {
    (navigator as any).clipboard.writeText(row.userId);
    this.toastrService.success('User ID copied to clipboard');
  }

}



// WEBPACK FOOTER //
// ./src/app/developer/auth-tools/failed-logins/failed-logins.component.ts